<template>
  <div
    v-if="categoryDescription && categoryTitle"
    class="category-info-wrapper"
  >
    <h1 class="category-info-wrapper__title">
      {{ categoryTitle }}
    </h1>
    <div class="category-info-wrapper__description">
      {{ categoryDescriptionShown }}
      <a
        v-if="categoryDescriptionShown && categoryDescriptionShown.length >= 230"
        class="category-info-wrapper__load"
        @click="toggleExpand"
      >
        <strong> {{ isExpanded ? $t('Read Less') : $t('Read More') }} </strong>
      </a>
    </div>
  </div>
</template>
<script>
import {
  computed, defineComponent, ref, useFetch,
} from '@nuxtjs/composition-api';
import { useCategorySearch } from '@vue-storefront/gemini';

export default defineComponent({
  name: 'CategoryDescription',
  props: {
    categoryId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { result: categorySearchResult, search: categorySearch } = useCategorySearch(`categorySearch:${props.categoryId}`);
    const isExpanded = ref(false);
    const categoryDescription = ref();
    const categoryTitle = ref();
    const categoryDescriptionShown = computed(() => {
      if (!isExpanded.value && categoryDescription.value && categoryDescription.value.length >= 230) {
        return `${categoryDescription.value.slice(0, 230)}...`;
      }
      return categoryDescription.value;
    });

    const toggleExpand = () => { isExpanded.value = !isExpanded.value; };
    useFetch(async () => {
      await categorySearch({
        filters: {
          category_uid: {
            eq: props.categoryId,
          },
        },
      });
      categoryDescription.value = categorySearchResult.value[0].description;
      categoryTitle.value = categorySearchResult.value[0].name;
    });
    return {
      categoryDescriptionShown,
      categoryDescription,
      categoryTitle,
      isExpanded,
      toggleExpand,
    };
  },
});
</script>
<style lang='scss'>
.category-info-wrapper {
  max-width: 77.875rem;
  margin: 0 auto;
  text-align: center;
  padding: 3.125rem 0;
  @include for-mobile {
    padding: 3.125rem 1.5rem;
  }
   h1 {
     @include for-mobile {
       font-size: 1.875rem;
       line-height: 2.25rem;
     }
     color: #141e16;
     font-family: 'Frank Ruhl Libre';
     font-size: 2.8125rem;
     font-weight: 400;
     letter-spacing: 0;
     line-height: 4.375rem;
     margin-bottom: 0.75rem;
   }
  &__description {
    @include for-mobile {
      font-size: 0.75rem;
      line-height: 1.25rem;
    }
    font-family: 'Spartan';
    font-size: 1rem;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 1.4375rem;
  }
  &__load {
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
